export default __webpack_public_path__ + "static/media/fevr-bm-icon-6.be1e8680.svg";